/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Partner_Managed_DescInputs */



/**
* | output |
* | --- |
* | "This organization is managed by your partner. Billing is handled externally." |
*
* @param {Sub_Partner_Managed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_partner_managed_desc = /** @type {((inputs?: Sub_Partner_Managed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Partner_Managed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Organisation wird von Ihrem Partner verwaltet. Die Abrechnung erfolgt extern.")
	return /** @type {LocalizedString} */ ("This organization is managed by your partner. Billing is handled externally.")
});